export default function Footer() {
  const col1 = [
    { href: "#timeline", label: "历史时间线" },
    { href: "#series", label: "往期合集" },
    { href: "#recap", label: "精选回顾" },
    { href: "#faq", label: "常见问题" },
  ];
  const col2 = [
    { href: "#about", label: "关于我们" },
    { href: "#contact", label: "投稿与反馈" },
    { href: "#home", label: "返回顶部" },
  ];

  return (
    <footer className="bg-background-200 text-foreground-800">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-[1.6fr_1fr_1fr] gap-8">
          <div>
            <a href="#home" className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading text-lg font-bold">四</span>
              <span className="font-heading text-xl font-bold text-foreground-950">四一爆料</span>
            </a>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 max-w-sm">
              把散落在热点里的瓜料，按事件顺序重新排好序。历史时间线汇总、往期系列合集、精选回顾，帮你在任何时间点都能回看完整脉络。
            </p>
            <div className="mt-5 flex gap-3">
              {[
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-wechat-line", label: "微信" },
                { icon: "ri-mail-line", label: "邮件" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#contact"
                  aria-label={s.label}
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-50 text-foreground-600 hover:text-primary-600 hover:bg-background-50/60 transition-colors border border-background-300"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="内容导航">
            <h4 className="text-sm font-bold text-foreground-950 mb-4">内容导航</h4>
            <div className="flex flex-col gap-2.5">
              {col1.map((l) => (
                <a key={l.href + l.label} href={l.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors w-fit whitespace-nowrap">
                  {l.label}
                </a>
              ))}
            </div>
          </nav>

          <nav aria-label="关于导航">
            <h4 className="text-sm font-bold text-foreground-950 mb-4">关于我们</h4>
            <div className="flex flex-col gap-2.5">
              {col2.map((l) => (
                <a key={l.href + l.label} href={l.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors w-fit whitespace-nowrap">
                  {l.label}
                </a>
              ))}
            </div>
          </nav>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© {new Date().getFullYear()} 四一爆料 · 内容基于公开信息整理</p>
          <p className="text-xs text-foreground-500">脉络归档 · 时间线汇总 · 系列合集</p>
        </div>
      </div>
    </footer>
  );
}